import { Schema as S } from "effect";

import { apiData } from "../../api/asyncData";
import { ApiKeyList } from "../../api/schemas/integrations";
import {
	GradeFilter,
	TaskPage,
	TaskPriority,
	TaskSort,
	TaskStatus,
} from "../../api/schemas/tasks";

/** The loaded rows plus the instant they were read (`now` for relative times, from Clock). */
export const Loaded = S.Struct({ ...TaskPage.fields, now: S.Number });
export type Loaded = typeof Loaded.Type;

export const Filters = S.Struct({
	/** The applied search; `draftQuery` is the box until submitted. */
	query: S.String,
	statuses: S.Array(TaskStatus),
	priorities: S.Array(TaskPriority),
	tags: S.Array(S.String),
	graded: GradeFilter,
	sort: TaskSort,
});
export type Filters = typeof Filters.Type;

export const Model = S.Struct({
	page: S.Literal("Tasks"),
	filters: Filters,
	draftQuery: S.String,
	/** Live data (KTD8): tasks are not time-versioned, so no asOf tag. */
	tasks: apiData(Loaded).schema,
	/** Bumped per list fetch; a result for an older filter set or page is dropped. */
	fetchSeq: S.Number,
	loadingMore: S.Boolean,
	/** Api keys, to name agent assignees. A failure falls back to the generic label. */
	keys: apiData(ApiKeyList).schema,
	/** Parents whose children are hidden. */
	collapsed: S.Array(S.String),
	newTitle: S.String,
	creating: S.Boolean,
	/** The last failed write (or a 412 conflict notice); cleared by the next write. */
	alert: S.Option(S.String),
});
export type Model = typeof Model.Type;
